// extracted by mini-css-extract-plugin
module.exports = {"hotspotProductCardWraper":"Hotspot_hotspotProductCardWraper__lT6qX"};